<!-- <template>
    <div class="sidebar primary" :class="{ 'show': sideBarState }">
        <fa v-if="sideBarState" icon="fa-xmark" class="icon-close" @click="changeSideBarState"/>
        <div class="sidebar-header">
            <div class="header-logo">
                <div class="logo" id="desktopLogoWeflix">
                    <img class="logo_black" src="@/assets/Weflix/Weflix-Logo-Total-Branco.png" >
                    <img class="logo_white" src="@/assets/Weflix/logo_weflix.png" >
                </div>
                <div class="logo-mobile">
                    <span><img src="@/assets/Weflix/icons/Weflix-Icone-Branco.svg" alt=""></span>
                    <span class="mobile-icon-weflix-text"><img src="@/assets/Weflix/icons/Weflix-Escrita-Branco.svg" alt=""></span>
                </div>
            </div>
        </div>
        <div class="sidebar-content">
            <div class="content-link">
                <div class="link" v-for="(itens, index) in dataSidebar" :key="index">
                    <router-link class="link-content primary" :to="itens.link" :class="{ active: activeIndex == index }"
                        @click="setActiveIndex(index)">
                        <span class="link-icon">
                            <fa :icon="itens.icon"  style="font-size: 1rem"/>

                        </span>
                        <span class="link-text">
                            <span class="text">
                               {{ itens.name }}
                            </span>
                        </span>
                    </router-link>
                </div>
                <div class="link dad" v-if="!isMobile">
                    <a class="link-content primary" href="#"
                    @click="setActiveIndex(8)"
                    :class="{ active: activeIndex == 8 }"
                    >
                        <span class="link-icon">
                            <fa icon="fa-chart-line" style="font-size: 1rem;    margin-left: -10px;"/>

                        </span>
                        <span class="link-text">
                            <span class="text">
                                Relatórios
                            </span>
                        </span>
                    </a>
                    <div class="link subitem" v-for="(report, index) in typesReports" :key="index">
                        <router-link
                            class="link-content primary"
                            :to="linksReports[index]"
                            @click="setSecondIndex(index + 1), setActiveIndex(8)"
                            :class="{ active: secondoactiveindex === index + 1 }"
                        >
                            <span class="link-icon">
                                <fa :icon="iconsReports[index]" style="font-size: 1rem" />
                            </span>
                            <span class="link-text">
                                <span class="text">
                                    {{ report }}
                                </span>
                            </span>
                        </router-link>
                    </div>
                </div>
                <div class="link mobile-report">
                    <div class="link" v-for="(report, index) in typesReports" :key="index">
                        <router-link
                            class="link-content primary"
                            :to="linksReports[index]"
                            @click="setSecondIndex(index + 1), setActiveIndex(8)"
                            :class="{ active: secondoactiveindex === index + 1 }"
                        >
                            <span class="link-icon">
                                <fa :icon="iconsReports[index]" style="font-size: 1rem" />
                            </span>
                            <span class="link-text">
                                <span class="text">
                                    {{ report }}
                                </span>
                            </span>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="version-label">
                <small v-if="!isMobile">Versão: 1.1.2 (04/06/2025)</small>
                <center><small v-if="isMobile">Versão: 1.1.2</small></center>

            </div>
        </div>
    </div>
</template>


<script>
import store from '@/store';
import  { mapState,mapActions } from 'vuex';
import { loadAppVersion } from '@/utils/appVersion';

export default {
    data() {
        return {
            menu: [],
            activeIndex: 0,
            isMobile: false,
            secondoactiveindex:null,
            lenguage: "pt",
            label_lenguage: "Idioma",
            typeUser:'',
            typesReports: [ 'Clientes', 'Financeiro',],
            iconsReports: ['fa-chalkboard-user','fa-sack-dollar'],
            linksReports: ['/admin/relatorios/clientes','/admin/relatorios/financas'],
            dataSidebar:[
                {
                    name:'Visão Geral',
                    link:'/admin/painel',
                    icon:'fa-border-all',
                    type:'0'
                },
                {
                    name:'Coleções',
                    link:'/admin/colecoes',
                    icon:'fa-clapperboard',
                    type:'0'
                },
                // {
                //     name:'Anexos',
                //     link:'/admin/anexos',
                //     icon:'fa-file-lines',
                //     type:'0'
                // },
                {
                    name:'Layout',
                    link:'/admin/personalizar',
                    icon:'fa-paintbrush',
                    type:'0'
                },
                {
                    name:'Pagamentos',
                    link:'/admin/pagamentos',
                    icon:'fa-money-check-dollar',
                    type:'0'
                },
                {
                    name:'Configurações',
                    link:'/admin/configuracoes',
                    icon:'fa-gears',
                    type:'1'
                },
                {
                    name:'Financeiro',
                    link:'/admin/conta',
                    icon:'fa-building-columns',
                    type:'1'
                },
                {
                    name:'Usuários',
                    link:'/admin/usuarios',
                    icon:'fa-user-plus',
                    type:'1'
                },
            ],
            isMobile: window.innerWidth <= 500
        };
    },
    computed: {
        ...mapState(['sideBarState'])
    },
    methods: {
        ...mapActions(['storeTypeId','storeSideBarState']),

        changeType(){
            this.storeTypeId({typeId: this.typeUser})
        },
        setActiveIndex(index) {
            if (this.activeIndex === index) {
                // this.activeIndex = null;
            } else {
                if(this.setActiveIndex!=8){
                    this.secondoactiveindex=null;
                }
                this.activeIndex = index;
            }
            localStorage.setItem('activeIndex', this.activeIndex);
        },
        setSecondIndex(index){
            if(this.secondoactiveindex===index){

            } else {
                this.secondoactiveindex = index;
            }
            localStorage.setItem('activeSecondIndex', this.secondoactiveindex);
            localStorage.setItem('activeIndex', this.activeIndex);
        },
        changeLenguage() {

            this.menu = require('../../locale/pt/sidebar.json');

            localStorage.setItem('lenguage', this.lenguage);

            const lenguage = localStorage.getItem('lenguage');

            this.lenguage = lenguage;

        },
        tranformtext(index) {
            if (index == "pt") {
                return 'Português';
            } else if (index == "en") {
                return 'English'
            } else if (index == "es") {
                return 'Español'
            }
        },
        changeSideBarState(){
            let aux = this.sideBarState;
            this.storeSideBarState({sideBarState:!aux})
        },
        checkScreenSize() {
            this.isMobile = window.innerWidth <= 500;
        }
    },
    mounted() {
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
        this.isMobile = window.innerWidth <= 600;
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    created() {

        this.typeUser = store.state.typeId;
        const savedActiveIndex = localStorage.getItem('activeIndex');
        const savedSecondoActiveIndex = localStorage.getItem('activeSecondIndex');
        if (savedActiveIndex !== null) {
            this.activeIndex = parseInt(savedActiveIndex, 10);
        }
        if (savedSecondoActiveIndex !== null) {
            this.secondoactiveindex = parseInt(savedSecondoActiveIndex, 10);
        }

        const lenguage = localStorage.getItem('lenguage');

        if (lenguage == null) {
            this.menu = require('../../locale/pt/sidebar.json');
            
        } else {

            this.menu = require('../../locale/pt/sidebar.json');
        }
    }
}
</script>
<style scoped>
.logo img {
    width: 150px;
}
.link.subitem {
    margin-left: 13%;
    margin-top: 2%;
    margin-bottom: 2%;
}
.link.dad {
    height: 46px;
    overflow: hidden;
    transition: all 500ms linear;
    margin-left: 0.5rem;
}
.link.dad:hover {
    overflow: visible;
    height: 145px;
}
.link.dad > a.link-content.primary {
    cursor: default;
}
.dashboard.dark img.logo_black {
    display: none;
}
.dashboard img.logo_white {
    display: none;
}
.dashboard.dark img.logo_white {
    display: block;
}
.version-label {
    position: absolute;
    bottom: 10px;
    left: 10px;
    color: #b1b1b1;
    font-size: 12px;
}
</style>

<style scoped>
.link.dad .link-content.primary .link-icon {
    margin-right: 1rem !important; 
}
.sidebar.primary .sidebar-content .content-link .link .link-content {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
    text-decoration: none;
    padding: 0.5rem 1rem;
    color: white;
    transition: .3s ease;
}
.sidebar.primary {
    position: fixed;
    height: 100%!important;
    z-index: 1040;
    width: 15%;
    left: 0;
    overflow: hidden;
    padding: 0.5rem;
    background-color: #260791;

}
@media only screen and (min-width:1900px){
    .sidebar.primary {
        position: fixed;
        height: 100%!important;
        z-index: 1040;
        width: 15%;
        left: 0;
        overflow: hidden;
        padding: 0.5rem;
        background-color: #260791;
        border-right: 1px solid #f6f6f6;
        transition: .5s ease;
        box-shadow: 2px -1px 22px -15px gray;
        margin-left: 0px;
    } 
}
.sidebar.primary .sidebar-header {
    padding: 1rem !important;
    padding-top: 5px!important;
}
.sidebar.primary .sidebar-content {
    overflow-y: auto;
    height: calc(100vh - 128px);
}
.sidebar.primary .sidebar-content .content-link {
    display: flex;
    height: calc(100vh - 10rem);
    flex-direction: column;
    gap: 1px;
}
.sidebar.primary .sidebar-content .content-link .link {
    display: block;
}

.sidebar.primary .sidebar-content .content-link .link .link-content .link-icon {
    display: inline-block;
    margin-right: 0.5rem;
    transition: .2s ease;
}
.sidebar.primary .sidebar-content .content-link .link .link-content.active {
    background-color: #150065;
    transition: .3s ease;
}


.sidebar.primary .sidebar-content .content-link .link .link-content:hover {
    color: #fff;
    background-color: #150065;
    transition: .2s ease;
}

.sidebar.primary .sidebar-content .content-link .link .link-content:hover {
    color: #fff;
    background-color: #150065;
    transition: .2s ease;
}
.sidebar.primary .sidebar-content .content-link .link .link-content:hover .link-text>span.text {
    transform: translateX(1rem);
    transition: transform .4s ease,color .1s ease;
}
.sidebar.primary .sidebar-content .content-link .link .link-content .link-text {
    display: flex;
    align-items: center;
    width: 100% !important;
    justify-content: space-between;
}
.sidebar.primary .sidebar-content .content-link .link .link-content:hover .link-icon {
    transform: translateX(0.75rem);
    transition: .2s ease;
    transition-delay: .15s;
}
.sidebar.primary .sidebar-content .content-link .link .link-content:hover .link-icon svg path {
    fill: #fff;
    transition: .3s ease;
}

.sidebar.primary .sidebar-content .content-link .link .link-content.active .link-icon svg path {
    fill: #fff;
    transition: .3s ease;
}
.sidebar.primary .sidebar-content .content-link .link .link-content.active span.link-icon, .sidebar.primary .sidebar-content .content-link .link .link-content.active .text {
    color: white;
}
.link-icon svg.svg-inline--fa {
    color: #ffffff;
}
.sidebar.primary.show {
    width: 200px;
}
svg.svg-inline--fa.fa-xmark.icon-close {
    position: absolute;
    transform: translate(75px, 10px);
}
.logo-mobile {
    display: none;
}
@media (min-width: 501px) {
    .mobile-report {
        display: none !important;
    }
}
@media (max-width: 500px) {
    .sidebar.primary {
        width: 60px;
        transition: .5s ease;
    }
    .sidebar.primary.show {
        width: 61%;
    }
    .sidebar.primary .sidebar-content .content-link .link .link-content .link-text {
        display: flex;
        align-items: center;
        width: 100% !important;
        justify-content: space-between;
        margin-left: 0.8em;
        max-height: 40px;
    }
    .sidebar.primary .sidebar-content .content-link .link .link-content:hover .link-icon {
        transform: translateX(0);
        transition: .2s ease;
        transition-delay: .15s;
    }
    .link .link-icon {
        display: inline-block;
        margin-left: -10px;
    }
    .link.dad .link-icon {
        margin-left: 0px;
    }
    .sidebar.primary .sidebar-content .content-link .link .link-content:hover .link-icon {
        transform: none !important;
        transition: .2s ease;
        transition-delay: .15s;
    }
    .sidebar.primary .sidebar-content .content-link .link .link-content.active {
        background-color: #150065;
        transition: .3s ease;
        border-radius: 10px;
    }
    .icon-close {
        color: #fff;
        padding: 5px;
    }
    .sidebar.primary .sidebar-header {
        padding: 1rem !important;
        padding-left: 3px!important;
        padding-top: 5px!important;
    }
    .link.subitem {
        margin-left: -10px;
        margin-top: 0;
        margin-bottom: 0;
    }
    .link.dad {
        height: 46px;
        overflow: visible;
        transition: none;
    }
    .logo img {
        width: 160px;
    }
    #desktopLogoWeflix {
        display: none;  
    }
    .logo-mobile {
        display: flex;
        align-items: center;
        gap: 50px;
    }
    .logo-mobile img {
        width: 40px;
    }
    .mobile-icon-weflix-text {
        width: 60px;
        transform: scale(2.3);
    }
}
</style> -->
<template>
    <div
        class="backdrop"
        v-if="sideBarState && isMobile"
        @click="changeSideBarState(false)"
    ></div>
    <div
        class="sidebar primary weflix-admin-sidebar"
        :class="{ show: sideBarState }"
    >
        <fa
            v-if="sideBarState && isMobile"
            icon="fa-xmark"
            class="icon-close"
            @click="changeSideBarState(false)"
        />
        <!--Header Section-->

        <div class="sidebar-header">
            <div class="header-logo">
                <div
                    class="logo"
                    id="desktopLogoWeflix"
                    v-show="!isMobile || sideBarState"
                >
                    <img
                        class="logo_black"
                        src="@/assets/Weflix/Weflix-Logo-Total-Branco.png"
                    />
                    <img
                        class="logo_white"
                        src="@/assets/Weflix/logo_weflix.png"
                    />
                </div>
                <div class="logo-mobile" v-show="isMobile && !sideBarState">
                    <span
                        ><img
                            src="@/assets/Weflix/icons/Weflix-Icone-Branco.svg"
                            alt=""
                    /></span>
                </div>
            </div>
        </div>

        <!--Content Section-->

        <div class="sidebar-content">
            <div class="content-link">
                <div
                    class="link"
                    v-for="(itens, index) in dataSidebar"
                    :key="index"
                >
                    <router-link
                        class="link-content primary"
                        :to="itens.link"
                        :class="{ active: activeIndex == index }"
                        @click="setActiveIndex(index)"
                    >
                        <span class="link-icon">
                            <fa :icon="itens.icon" style="font-size: 1rem" />
                        </span>
                        <span
                            class="link-text"
                            v-show="!isMobile || sideBarState"
                        >
                            <span class="text">
                                {{ itens.name }}
                            </span>
                        </span>
                    </router-link>
                </div>

                <!-- Relatórios para Desktop -->
                <div class="link dad" v-if="!isMobile">
                    <a
                        class="link-content primary"
                        href="#"
                        @click="setActiveIndex(8)"
                        :class="{ active: activeIndex == 8 }"
                    >
                        <span class="link-icon">
                            <fa icon="fa-chart-line" style="font-size: 1rem" />
                        </span>
                        <span class="link-text">
                            <span class="text"> Relatórios </span>
                        </span>
                    </a>
                    <div
                        class="link subitem"
                        v-for="(report, index) in typesReports"
                        :key="index"
                    >
                        <router-link
                            class="link-content primary"
                            :to="linksReports[index]"
                            @click="
                                setSecondIndex(index + 1), setActiveIndex(8)
                            "
                            :class="{
                                active: secondoactiveindex === index + 1,
                            }"
                        >
                            <span class="link-icon">
                                <fa
                                    :icon="iconsReports[index]"
                                    style="font-size: 1rem"
                                />
                            </span>
                            <span class="link-text">
                                <span class="text">
                                    {{ report }}
                                </span>
                            </span>
                        </router-link>
                    </div>
                </div>

                <!-- Relatórios para Mobile -->
                <div class="link mobile-report" v-if="isMobile">
                    <!-- Link principal dos relatórios no mobile -->
                    <div class="link">
                        <a
                            class="link-content primary"
                            href="#"
                            @click="setActiveIndex(8)"
                            :class="{ active: activeIndex == 8 }"
                        >
                            <span class="link-icon">
                                <fa
                                    icon="fa-chart-line"
                                    style="font-size: 1rem"
                                />
                            </span>
                            <span class="link-text" v-show="sideBarState">
                                <span class="text"> Relatórios </span>
                            </span>
                        </a>
                    </div>
                    <!-- Subitens dos relatórios no mobile -->
                    <div
                        class="link subitem-mobile"
                        v-for="(report, index) in typesReports"
                        :key="index"
                        v-show="sideBarState"
                    >
                        <router-link
                            class="link-content primary"
                            :to="linksReports[index]"
                            @click="
                                setSecondIndex(index + 1), setActiveIndex(8)
                            "
                            :class="{
                                active: secondoactiveindex === index + 1,
                            }"
                        >
                            <span class="link-icon">
                                <fa
                                    :icon="iconsReports[index]"
                                    style="font-size: 1rem"
                                />
                            </span>
                            <span class="link-text">
                                <span class="text">
                                    {{ report }}
                                </span>
                            </span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="sidebar-footer" v-show="!isMobile || sideBarState">
            <small>Versão: {{ versionLabel }}</small>
        </div>
    </div>
</template>

<script>
    import store from '@/store';
    import { mapState, mapActions } from 'vuex';
    import { loadAppVersion } from '@/utils/appVersion';

    export default {
        data() {
            return {
                menu: [],
                activeIndex: 0,
                isMobile: false,
                secondoactiveindex: null,
                lenguage: 'pt',
                label_lenguage: 'Idioma',
                typeUser: '',
                typesReports: ['Clientes', 'Financeiro'],
                iconsReports: ['fa-chalkboard-user', 'fa-sack-dollar'],
                linksReports: [
                    '/admin/relatorios/clientes',
                    '/admin/relatorios/financas',
                ],
                version: '',
                dataSidebar: [
                    {
                        name: 'Visão Geral',
                        link: '/admin/painel',
                        icon: 'fa-border-all',
                        type: '0',
                    },
                    {
                        name: 'Coleções',
                        link: '/admin/colecoes',
                        icon: 'fa-clapperboard',
                        type: '0',
                    },
                    {
                        name: 'Layout',
                        link: '/admin/personalizar',
                        icon: 'fa-paintbrush',
                        type: '0',
                    },
                    {
                        name: 'Pagamentos',
                        link: '/admin/pagamentos',
                        icon: 'fa-money-check-dollar',
                        type: '0',
                    },
                    {
                        name: 'Configurações',
                        link: '/admin/configuracoes',
                        icon: 'fa-gears',
                        type: '1',
                    },
                    {
                        name: 'Financeiro',
                        link: '/admin/conta',
                        icon: 'fa-building-columns',
                        type: '1',
                    },
                    {
                        name: 'Usuários',
                        link: '/admin/usuarios',
                        icon: 'fa-user-plus',
                        type: '1',
                    },
                ],
            };
        },
        computed: {
            ...mapState(['sideBarState']),
            versionLabel() {
                if (!this.version) return '';
                if (this.isMobile) return this.version.split(' - ')[0];
                return this.version;
            },
        },
        methods: {
            ...mapActions(['storeTypeId', 'storeSideBarState']),

            changeType() {
                this.storeTypeId({ typeId: this.typeUser });
            },
            setActiveIndex(index) {
                if (this.activeIndex === index) {
                    // this.activeIndex = null;
                } else {
                    if (this.setActiveIndex != 8) {
                        this.secondoactiveindex = null;
                    }
                    this.activeIndex = index;
                    this.changeSideBarState(false);
                }
                localStorage.setItem('activeIndex', this.activeIndex);
            },
            setSecondIndex(index) {
                if (this.secondoactiveindex === index) {
                } else {
                    this.secondoactiveindex = index;
                }
                localStorage.setItem(
                    'activeSecondIndex',
                    this.secondoactiveindex
                );
                localStorage.setItem('activeIndex', this.activeIndex);
                this.changeSideBarState(false);
            },
            changeLenguage() {
                this.menu = require('../../locale/pt/sidebar.json');
                localStorage.setItem('lenguage', this.lenguage);
                const lenguage = localStorage.getItem('lenguage');
                this.lenguage = lenguage;
            },
            tranformtext(index) {
                if (index == 'pt') {
                    return 'Português';
                } else if (index == 'en') {
                    return 'English';
                } else if (index == 'es') {
                    return 'Español';
                }
            },
            changeSideBarState(state) {
                console.log('State received:', state);
                const newState = state === undefined ? !this.sideBarState : state;
                console.log('New state:', newState);

                this.storeSideBarState({ sideBarState: newState });
            },
            checkScreenSize() {
                this.isMobile = window.innerWidth <= 768;
            },
        },
        mounted() {
            this.checkScreenSize();
            window.addEventListener('resize', this.checkScreenSize);
            loadAppVersion().then((data) => {
                this.version = data.weflix || '';
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkScreenSize);
        },
        created() {
            this.typeUser = store.state.typeId;
            const savedActiveIndex = localStorage.getItem('activeIndex');
            const savedSecondoActiveIndex =
                localStorage.getItem('activeSecondIndex');
            if (savedActiveIndex !== null) {
                this.activeIndex = parseInt(savedActiveIndex, 10);
            }
            if (savedSecondoActiveIndex !== null) {
                this.secondoactiveindex = parseInt(savedSecondoActiveIndex, 10);
            }

            const lenguage = localStorage.getItem('lenguage');
            if (lenguage == null) {
                this.menu = require('../../locale/pt/sidebar.json');
            } else {
                this.menu = require('../../locale/pt/sidebar.json');
            }
        },
    };
</script>

<style scoped>
    .backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .weflix-admin-sidebar.sidebar.primary {
        --sa-sidebar-bg: #260791;
        --sa-sidebar-active: #150065;
        --sa-sidebar-hover: rgba(21, 0, 101, 0.72);
        --sa-sidebar-text: rgba(255, 255, 255, 0.94);
        --sa-sidebar-muted: rgba(255, 255, 255, 0.72);

        position: fixed;
        top: 0;
        left: 0;
        z-index: 1040;
        width: 15%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        margin: 0;
        padding: 0.75rem 0.65rem 0.75rem;
        background-color: var(--sa-sidebar-bg);
        border-right: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 0;
        box-shadow: none;
        font-family: Inter, system-ui, -apple-system, 'Segoe UI', sans-serif;
        box-sizing: border-box;
    }

    .weflix-admin-sidebar .sidebar-header {
        flex-shrink: 0;
        padding: 0.85rem 0.55rem 1rem !important;
        margin: 0 0 0.5rem;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .weflix-admin-sidebar .header-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 40px;
    }

    .weflix-admin-sidebar .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .weflix-admin-sidebar .logo img {
        width: auto;
        max-width: 132px;
        height: auto;
        max-height: 36px;
        object-fit: contain;
        display: block;
    }

    .dashboard.dark .weflix-admin-sidebar img.logo_black,
    .dashboard.dark img.logo_black {
        display: none;
    }

    .dashboard .weflix-admin-sidebar img.logo_white,
    .dashboard img.logo_white {
        display: none;
    }

    .dashboard.dark .weflix-admin-sidebar img.logo_white,
    .dashboard.dark img.logo_white {
        display: block;
    }

    .weflix-admin-sidebar .logo-mobile {
        display: none;
    }

    .weflix-admin-sidebar .sidebar-content {
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        margin-top: 0;
        height: auto;
    }

    .weflix-admin-sidebar .content-link {
        display: flex;
        flex-direction: column;
        gap: 0.3rem;
        flex: 1 1 auto;
        min-height: 0 !important;
        height: auto !important;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0.15rem 0 0.5rem;
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 255, 255, 0.22) transparent;
    }

    .weflix-admin-sidebar .content-link::-webkit-scrollbar {
        width: 4px;
    }

    .weflix-admin-sidebar .content-link::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 99px;
    }

    .weflix-admin-sidebar .link {
        display: block;
    }

    .weflix-admin-sidebar .link-content {
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        gap: 0;
        font-style: normal;
        font-weight: 500;
        font-size: 0.8125rem;
        line-height: 1.35;
        letter-spacing: 0.01em;
        text-decoration: none;
        padding: 0.55rem 0.7rem 0.55rem 0.55rem;
        color: var(--sa-sidebar-text);
        border-radius: 10px;
        transition: background-color 0.2s ease, color 0.15s ease;
    }

    .weflix-admin-sidebar .link-content:focus-visible {
        outline: 2px solid rgba(199, 182, 254, 0.85);
        outline-offset: 1px;
    }

    .weflix-admin-sidebar .link-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 1.75rem;
        height: 1.75rem;
        margin-right: 0.65rem;
        color: #fff;
    }

    .weflix-admin-sidebar .link-icon :deep(svg) {
        width: 0.95rem;
        height: 0.95rem;
        font-size: 0.95rem;
        color: #fff;
    }

    .weflix-admin-sidebar .link-text {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: flex-start;
        min-width: 0;
    }

    .weflix-admin-sidebar .link-text .text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .weflix-admin-sidebar .link-content.active,
    .weflix-admin-sidebar .link-content.router-link-exact-active {
        background-color: var(--sa-sidebar-active);
        color: #fff;
    }

    .weflix-admin-sidebar .link-content:hover {
        color: #fff;
        background-color: var(--sa-sidebar-hover);
    }

    .weflix-admin-sidebar .link-content.active:hover,
    .weflix-admin-sidebar .link-content.router-link-exact-active:hover {
        background-color: var(--sa-sidebar-active);
    }

    .weflix-admin-sidebar .link.dad {
        height: auto;
        overflow: visible;
        margin: 0;
    }

    .weflix-admin-sidebar .link.dad > a.link-content.primary {
        cursor: default;
    }

    .weflix-admin-sidebar .link.subitem,
    .weflix-admin-sidebar .link.subitem-mobile {
        margin: 0;
        padding-left: 0.85rem;
    }

    .weflix-admin-sidebar .sidebar-footer {
        flex-shrink: 0;
        margin-top: auto;
        padding: 0.65rem 0.55rem 0.15rem;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        color: var(--sa-sidebar-muted);
        font-size: 0.75rem;
        text-align: center;
    }

    .weflix-admin-sidebar .icon-close {
        position: absolute;
        top: 0.85rem;
        right: 0.75rem;
        color: #fff;
        cursor: pointer;
        z-index: 2;
        padding: 0.25rem;
    }

    @media only screen and (min-width: 1900px) {
        .weflix-admin-sidebar.sidebar.primary {
            box-shadow: 2px 0 22px -12px rgba(0, 0, 0, 0.35);
        }

        .weflix-admin-sidebar .logo img {
            max-width: 148px;
            max-height: 40px;
        }
    }

    @media (max-width: 768px) {
        .weflix-admin-sidebar.sidebar.primary {
            width: 60px;
            padding: 0.55rem 0.35rem;
            transition: width 0.35s ease;
        }

        .weflix-admin-sidebar.show {
            width: 72%;
            max-width: 280px;
        }

        .weflix-admin-sidebar .sidebar-header {
            padding: 0.65rem 0.25rem 0.85rem !important;
        }

        .weflix-admin-sidebar:not(.show) #desktopLogoWeflix {
            display: none;
        }

        .weflix-admin-sidebar .logo-mobile {
            display: none;
        }

        .weflix-admin-sidebar:not(.show) .logo-mobile {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
        }

        .weflix-admin-sidebar .logo-mobile img {
            width: 28px;
            height: auto;
        }

        .weflix-admin-sidebar:not(.show) .link-text,
        .weflix-admin-sidebar:not(.show) .sidebar-footer,
        .weflix-admin-sidebar:not(.show) .link.subitem,
        .weflix-admin-sidebar:not(.show) .link.subitem-mobile {
            display: none;
        }

        .weflix-admin-sidebar:not(.show) .link-content {
            justify-content: center;
            padding: 0.55rem;
        }

        .weflix-admin-sidebar:not(.show) .link-icon {
            margin-right: 0;
        }

        .weflix-admin-sidebar.show .link-content {
            padding: 0.55rem 0.7rem 0.55rem 0.55rem;
        }

        .weflix-admin-sidebar.show .link.subitem,
        .weflix-admin-sidebar.show .link.subitem-mobile {
            display: block;
            padding-left: 0.85rem;
        }
    }
</style>
